import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';

/**
 * Simple previous / next pager for server-paginated lists. The first of
 * its kind in the app; keep it generic so other lists can adopt it.
 */
export function Pager({
  page,
  limit,
  total,
  onPage,
  noun = 'rows',
}: {
  page: number;
  limit: number;
  total: number;
  onPage: (page: number) => void;
  /** Plural noun for the count line, e.g. "people". */
  noun?: string;
}) {
  const pages = Math.max(1, Math.ceil(total / limit));
  if (total <= limit) return null;
  return (
    <div className="flex items-center justify-between gap-3 px-1 py-2">
      <span className="text-xs tabular-nums text-fg-muted">
        Page {Math.min(page, pages)} of {pages} · {total} {noun}
      </span>
      <div className="flex items-center gap-1.5">
        <Button
          variant="ghost"
          size="sm"
          iconLeft={<ChevronLeft className="h-4 w-4" />}
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
        >
          Previous
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconRight={<ChevronRight className="h-4 w-4" />}
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
